// Projeção única de uma etapa do roteiro gravada no snapshot do CP (`CartaoControleSnapshot.roteiro.etapas`).
// O formato canônico vem de `EtapaRoteiro` na API (roteiro-versao.repository.ts), copiado para
// `OrdemProducao.roteiroSnapshot` na liberação: `{ etapaOrdem, celulaId, descricao, ... }`.
// `ordem`/`nome`/`detalhe` são aceitos só como fallback de formatos antigos.

export const ETAPA_SEM_NOME = 'Etapa sem nome';

export interface EtapaDoRoteiro {
  readonly ordem: number;
  readonly nome: string;
  readonly detalhe?: string;
}

function textoPreenchido(valor: unknown): string | undefined {
  return typeof valor === 'string' && valor.trim() !== '' ? valor.trim() : undefined;
}

function numeroValido(valor: unknown): number | undefined {
  return typeof valor === 'number' && Number.isFinite(valor) ? valor : undefined;
}

/** Lê uma etapa do snapshot; `indice` dá a ordem quando o snapshot não traz nenhuma. */
export function etapaDoRoteiro(valor: unknown, indice: number): EtapaDoRoteiro {
  if (typeof valor !== 'object' || valor === null) return { ordem: indice + 1, nome: ETAPA_SEM_NOME };
  const etapa = valor as Record<string, unknown>;
  const celula = textoPreenchido(etapa.celulaId);
  return {
    ordem: numeroValido(etapa.etapaOrdem) ?? numeroValido(etapa.ordem) ?? indice + 1,
    nome: textoPreenchido(etapa.descricao) ?? textoPreenchido(etapa.nomeServico) ?? textoPreenchido(etapa.codigoServico) ?? textoPreenchido(etapa.nome) ?? ETAPA_SEM_NOME,
    detalhe: celula ? `Célula ${celula}` : textoPreenchido(etapa.detalhe),
  };
}

export function etapasDoRoteiro(etapas: readonly unknown[]): readonly EtapaDoRoteiro[] {
  return etapas.map(etapaDoRoteiro);
}
